//Api end points

export const usersApi = {
  endPoint: "/auth/v1/user",
};

export const questionApi = {
  endPoint: "/exams/v1/questionBank",
};

export const faqApi = {
  endPoint: `api/admin/v1/faq`,
};

export const subjectApi = {
  endPoint: `exams/v1/subject`,
};

export const entityTypeApi = {
  endPoint: `exams/v1/entity`,
};
export const entityApi = {
  endPoint: `exams/v1/businessSubCategory`,
  categoryEndPoint: `exams/v1/businessCategory`,
};

export const topicApi = {
  endPoint: `exams/v1/topic`,
};


export const subTopicApi = {
  endPoint: `exams/v1/subtopic`,
};

export const instructionsApi = {
  endPoint: `exams/v1/instructions`,
};

export const termsApi = {
  endPoint: `exams/v1/terms`,
};

export const tipsApi = {
  endPoint: `exams/v1/tips`,
};

export const percentileApi = {
  endPoint: `exams/v1/percentile`,
};

export const mocksApi = {
  endPoint: `exams/v1/mockTest`,
};

export const mockPackageApi = {
  endPoint: `exams/v1/mockPackage`,
};

export const classApi = {
  endPoint: `exams/v1/classes`,
};

export const assignmentApi = {
  endPoint: `exams/v1/assignment`,
};
export const groupApi = {
  endPoint: `exams/v1/group`,
};
export const videoBank = {
  endPoint: `exams/v1/videoBank`,
};
export const classVideo = {
  endPoint: `exams/v1/event/video`,
};

export const noteBank = {
  endPoint: `exams/v1/notesBank`,
};
export const courseApi = {
  endPoint: `/exams/v1/course`,
};
export const examSpecficaton = {
  endPoint: `/exams/v1/specification`,
};
export const learnApi = {
  endPoint: `/exams/v1/learn`,
};
export const publishApi = `exams/v1/published/status/update`

export const pastPaperApi = {
  endPoint: `/exams/v1/pastPaper`,
};
export const practiceQaApi = {
  endPoint: `/exams/v1/practiceQa`,
};
export const dailyQuiz = {
  endPoint: `/exams/v1/dailyQuiz`,
};
export const moduleApi = {
  endPoint: `/exams/v1/module`,
};
export const accelareaderApi = {
  endPoint: `/exams/v1/accelareader/basic`,
};
export const productApi = {
  endPoint: `/exams/v1/products`,
};
export const eventApi = {
  endPoint: `/exams/v1/event/basic`,
};
export const blogApi = {
  endPoint: `/admin/v1/blogs/basic`,
  tagsEndPoint: `/admin/v1/blogs/tag`,
  categoryEndPoint: `/admin/v1/blogCategory`,
};
export const rewardsApi = {
  referralEndPoint: `/exams/v1/referral`,
  bundleEndPoint: `/admin/v1/bundle`,
  rewardsEndPoint: `/exams/v1/rewards`,
};

export const dailyStreakApi = {
  endPoint: `exams/v1/rewards/daily`,
};

export const doubtApi = {
  endPoint: `exams/v1/doubts`,
};

export const onboardingApi = {
  endPoint: `/admin/v1/onboardingContent`,
};

export const feedAlgo = {
  endPoint: `exams/v1/feedAlgo`,
};

export const dashboardApi = {
  endPoint: `exams/v1/dashboard`,
};
export const notificationApi = {
  endPoint: `exams/v1/notification`,
};
export const interestApi = {
  endPoint: `admin/v1/interest`,
};


export const homeBannerApi = {
  endPoint: `exams/v1/homeBanner`,
};
export const announcementApi = {
  endPoint: `exams/v1/announcement`,
};

export const templateApi = {
  endPoint: `exams/v1/templates`,
};

export const sessionApi = {
  endPoint: `exams/v1/session`,
};

export const mockApi = {
  endPoint: `exams/v1/mock/session/`,
};

export const scheduleApi = {
  endPoint: `exams/v1/sales/schedule/spot`,
};

export const salesAnalysticApi = {
  endPoint: `exams/v1/sales/analytics`,
};

export const updateIsLiveStatus = {
  endPoint: `exams/v1/status`,
};


export const roleMgmt = {
  endPoint: `admin/v1/roles`,
};

export const studentApi = {
  endPoint: `auth/v1/student`,
};
export const helpRequestApi = {
  endPoint: `exams/v1/help`,
};
export const permissionApi = {
  endPoint: `admin/v1/roles/permission`,
};
//{{8004}}/exams/v1/dashboard/all/list?days=200&minAge=20&maxAge=30

export let imgUrl = 'https://media.iquanta.in/media/logo/course_logo966976364.png'